import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import ClientForm from '../components/ClientForm';
import {
  requestClient,
  updateClient,
  requestClientsTypeahead,
  requestClientTPASubgroups,
} from '../../../store/client-manager/ClientManagerActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestLocations } from '../../../store/location-manager/LocationManagerActions';
import { hostTitle } from '../../../config/ui';

class ClientEdit extends React.Component {
  componentWillMount() {
    this.props.getClient(this.props.params.employerCodeNumber, {
      tenantId: this.props.tenantId,
    });
    this.props.getClientTPASubgroups({
      tenantId: this.props.tenantId,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.params.employerCodeNumber !==
      prevProps.params.employerCodeNumber
    ) {
      this.props.getClient(this.props.params.employerCodeNumber, {
        tenantId: this.props.tenantId,
      });
    }
  }

  onSubmit = (values) => {
    this.props
      .updateClient(values, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Client has been saved.');
          hashHistory.push('/client-manager/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/client-manager/');
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 20,
        order: '',
        search,
        filters,
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            const email = item.email ? ` (${item.email})` : '';
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}${email}`,
            });
          });
        }
        return options;
      });
  };

  searchClients = (search, filters = '') => {
    const employerCodeNumber = this.props.params.employerCodeNumber;
    return this.props
      .getClientsTypeahead({
        offset: 0,
        limit: 20,
        order: '',
        search,
        filters,
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) => {
            if (employerCodeNumber !== item.code) {
              options.push(item);
            }
          });
        }
        return options;
      });
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              clinicLocationID: item.clinicLocationID,
              siteName: item.siteName,
              name: `${item.siteName} (${item.clinicLocationID})`,
            }),
          );
        }
        return options;
      });
  };

  detailClient = (employerCodeNumber) => {
    hashHistory.push(`/client-manager/detail/${employerCodeNumber}`);
  };

  render() {
    const {
      data: { client, isLoading, tpaSubGroups },
    } = this.props;

    return (
      <div id="content">
        {client.employerCodeNumber && (
          <Helmet title={`${client.employerCodeNumber} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Client Manager', route: '/client-manager' },
            'Client',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>
                Edit Client{' '}
                {client.employerCodeNumber && (
                  <i>({client.employerCodeNumber})</i>
                )}
              </h2>
              <div className="widget-toolbar">
                <button
                  className="btn btn-primary btn-xs"
                  onClick={() => this.detailClient(client.employerCodeNumber)}
                >
                  <i className="fa fa-eye" />
                </button>
              </div>
            </header>
            <div>
              <div className="widget-body">
                {
                  <ClientForm
                    onSubmit={this.onSubmit}
                    onCancel={this.onCancel}
                    searchUsers={this.searchUsers}
                    searchClients={this.searchClients}
                    searchLocations={this.searchLocations}
                    isLoading={isLoading}
                    tpaSubGroups={tpaSubGroups}
                  />
                }
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.clientmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getClientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    getClient: (employerCodeNumber, params) =>
      dispatch(requestClient(employerCodeNumber, params)),
    updateClient: (client, params) => dispatch(updateClient(client, params)),
    locationsTypeahead: (params) => dispatch(requestLocations(params)),
    getClientTPASubgroups: (params) => dispatch(requestClientTPASubgroups(params)),
  }),
)(ClientEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/ClientEdit.js